export function getContext(route) {
    return {
        organisationId: route.params.organisationId,
        appId: route.params.appId,
        panelId: route.params.panelId
    };
}